import {
  selectConfig,
  selectCreditInfo,
  selectFeaturedAds,
  selectSesameCash,
  selectUserInfo,
} from 'selectors/api.selector';
import { selectPageState } from 'selectors/page.selector';

export const selectStandardSecureData = state => ({
  loggedIn: state.app.loggedIn,
  loggingIn: state.app.loggingIn,
  ocfLoggedIn: state.app.ocfLoggedIn,
  ocfInfo: state.ocfInfo.ocfInfo,
  pageNameMeta: state.tracking.pageNameMeta,
  ...selectPageState(state),
  ...selectUserInfo(state),
  ...selectCreditInfo(state),
  ...selectConfig(state),
  ...selectSesameCash(state),
  ...selectFeaturedAds(state),
});
